"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_router_dom_1 = require("react-router-dom");
var components_1 = __importDefault(require("./components"));
var Product_1 = __importDefault(require("./components/Product"));
var Category_1 = __importDefault(require("./components/Category"));
var CategoryList_1 = __importDefault(require("./components/CategoryList"));
var Order_1 = __importDefault(require("./components/Dashboard/Order"));
$(document).ready(function () {
    ICWidgets.Client.on("init-complete", function (appRoutes) {
        var appElement = document.getElementById("app");
        var productElement = document.getElementById("product-widget");
        var categoryElement = document.getElementById("category-widget");
        var categoryListElement = document.getElementById("category-list-widget");
        var orderElement = document.getElementById("order-widget");
        appElement &&
            react_dom_1.render(React.createElement(react_router_dom_1.BrowserRouter, null,
                React.createElement(components_1.default, null)), appElement);
        productElement && react_dom_1.render(React.createElement(Product_1.default, null), productElement);
        categoryElement &&
            react_dom_1.render(React.createElement(react_router_dom_1.BrowserRouter, null,
                React.createElement(Category_1.default, null)), categoryElement);
        categoryListElement &&
            react_dom_1.render(React.createElement(react_router_dom_1.BrowserRouter, null,
                React.createElement(CategoryList_1.default, null)), categoryListElement);
        orderElement && react_dom_1.render(React.createElement(Order_1.default, null), orderElement);
    });
});
